import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";
import EnquiryForm from "@/components/EnquiryForm";

const EnquiryDialog = ({ trigger, poojaName = "", poojaSlug = "" }) => {
  const [open, setOpen] = useState(false);
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto bg-[#FAFAF8]">
        <DialogHeader>
          <DialogTitle className="font-heading text-3xl text-secondary">
            {poojaName ? `Enquire: ${poojaName}` : "Send an Enquiry"}
          </DialogTitle>
          <p className="text-sm text-muted-foreground">Our priest team responds quickly with honest guidance.</p>
        </DialogHeader>
        <EnquiryForm poojaName={poojaName} poojaSlug={poojaSlug} onSuccess={() => setOpen(false)} />
      </DialogContent>
    </Dialog>
  );
};

export default EnquiryDialog;
